// This file is use to set global svelte components for django templates
// @ts-ignore
import EMSXSearchBar from "./components/common/htmlInjections/EMSXSearchBar.svelte";

window["EMSXSearchBar"] = function (options) {
  return new EMSXSearchBar(options);
};
